<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>{{ title }}</title>
  </head>
  <body>
    <!-- <div
      *ngIf="gothrough == false"
      class="container"
      style="text-align: center"
    >
      <label for="Identifiant" style="margin-right: 1%">Identifiant</label>
      <input type="password" [(ngModel)]="password" style="margin-top: 25%" />
      <button style="margin-left: 1%" (click)="validatePassword()">
        Valider
      </button>
      <p
        *ngIf="showError"
        style="color: red; display: inline-block; margin-left: 1%"
      >
        Mot de passe incorrect
      </p>
    </div> -->

    <header>
      <app-header></app-header>
    </header>
    <router-outlet></router-outlet>

    <footer>
      <app-footer></app-footer>
    </footer>

    <!-- The core Firebase JS SDK is always required and must be listed first -->
    <!-- <script src="https://www.gstatic.com/firebasejs/8.7.1/firebase-app.js"></script> -->

    <!-- TODO: Add SDKs for Firebase products that you want to use
   https://firebase.google.com/docs/web/setup#available-libraries -->
    <!-- <script src="https://www.gstatic.com/firebasejs/8.7.1/firebase-analytics.js"></script> -->
  </body>
</html>
